export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11027.4f88a5e9.jpg";